<ng-template #footerTmpl>
  @if (active()) {
    <div class="footer" [class.no-padding-bottom]="!!replyToId()" padding-top-small>
      @if (attachmentsTemp()?.length || note()?.attachments?.length || attachmentLoading()) {
        <rt-divider variant="line dark" />
      }
      @if (attachmentLoading()) {
        <rt-spinner variant="small" />
      }
      @for (tempUpload of attachmentsTemp(); track tempUpload.attachment.id) {
        <rt-attachment-item
          [attachment]="tempUpload.attachment"
          [hasDeleteAction]="canDeleteAttachments()"
          (deleteClick)="deleteAttachment($event)"
          type="list-item"
          margin-bottom-small
        />
      }
      @if (note(); as noteValue) {
        @for (attachment of noteValue.attachments; track attachment.id) {
          <rt-attachment-item
            [attachment]="attachment"
            [hasDeleteAction]="canDeleteAttachments()"
            (deleteClick)="deleteAttachment($event)"
            type="list-item"
            margin-bottom-small
          />
        }
      }

      @let visibilitySelector = hasVisibilityOptions() && visibilitySelectorComponent();
      @if (!attachmentsTemp()?.length && !note()?.attachments?.length && visibilitySelector) {
        <rt-divider variant="line dark" margin-bottom-small />
      }
      <div class="footer-actions" (mousedown)="setKeepFocus()">
        @if (visibilitySelector) {
          <ng-template
            [rtComponentOutlet]="visibilitySelector"
            [rtComponentOutletInputs]="resolvedVisibilitySelectorInputs()"
            [rtComponentOutletOutputs]="{
              visibilityChanges: onVisibilityChanges,
            }"
          />
        }
      </div>
    </div>
  }
</ng-template>

<input #fileInput type="file" hidden (change)="uploadAttachment(fileInput.files, fileInput)" />

<div class="form" [class.active]="active()">
  <div
    class="mentions-input"
    [class.mentions-input--active]="active()"
    rtWysiwygContextTooltipContainer
  >
    <rt-wysiwyg
      prosemirrorGroupedConfig
      [formControl]="wysiwygControl"
      [placeholder]="placeholder()"
      [actionButtons]="actionButtons()"
      [withBorder]="false"
      [toolbarVisible]="active()"
      [footerTmpl]="footerTmpl"
      [autofocus]="autofocus()"
      [config]="ProsemirrorGroupedConfig"
      (focusChange)="onFocusChange($event)"
      (editorEvents)="onEditorEvents($event)"
    />
  </div>
</div>

@if (active()) {
  <ng-container *ngTemplateOutlet="actionsTpl" />
}
<ng-template #actionsTpl>
  <div margin-tb-small>
    <rt-group variant="horizontal" layout-justify-flex-end>
      <rt-button variant="plain" (click)="cancel()" margin-right-small>
        {{ notesTranslations.cancel | translate }}
      </rt-button>
      <rt-button
        class="action"
        variant="primary"
        [loading]="noteSaveLoading()"
        [disabled]="!isValid()"
        (mousedown)="setKeepFocus()"
        (click)="save()"
      >
        {{ notesTranslations.save | translate }}
      </rt-button>
    </rt-group>
  </div>
</ng-template>
